// YouTube モーダルの共通ロジック（snippets/youtube-modal.liquid から切り出し）。
// SEO台帳 F2: 以前はスニペットを描画するたびに約 34KB のインライン script として出力され、
// 1 ページに複数インスタンスがあると同じ内容が HTML に重複していた。アセット化して 1 回だけ読み込み、
// ブラウザキャッシュも効かせる。インスタンス生成は snippets/youtube-modal.liquid 側（RetouchYtModalReady 経由）。
(function() {
window.RetouchYtModal = window.RetouchYtModal || (function() {

  // ====== 表示ヘルパー（全インスタンス共有） ======
  function parseDuration(iso) {
    const m = iso.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);
    if (!m) return '';
    const h = parseInt(m[1] || 0), min = parseInt(m[2] || 0), sec = parseInt(m[3] || 0);
    if (h > 0) return `${h}:${String(min).padStart(2,'0')}:${String(sec).padStart(2,'0')}`;
    return `${min}:${String(sec).padStart(2,'0')}`;
  }

  function formatViews(n) {
    const num = parseInt(n || 0);
    if (num >= 10000) return Math.floor(num/10000) + '万';
    if (num >= 1000) return (num/1000).toFixed(1) + '千';
    return num.toLocaleString();
  }

  function timeAgo(dateStr) {
    const diff = (Date.now() - new Date(dateStr)) / 1000;
    if (diff < 3600)  return Math.floor(diff/60) + '分前';
    if (diff < 86400) return Math.floor(diff/3600) + '時間前';
    if (diff < 2592000) return Math.floor(diff/86400) + '日前';
    if (diff < 31536000) return Math.floor(diff/2592000) + 'ヶ月前';
    return Math.floor(diff/31536000) + '年前';
  }

function create(opts) {
  const SECTION_ID = opts.id;
  const IS_SHORTS = opts.isShorts;
  const PRODUCT_HANDLE = opts.productHandle || '';
  const CART_ICON_SVG = opts.cartIconSvg || '';

  const modal    = document.getElementById('yt-modal-' + SECTION_ID);
  const iframe   = document.getElementById('yt-modal-iframe-' + SECTION_ID);
  const closeBtn = document.getElementById('yt-modal-close-' + SECTION_ID);

  // ナビゲーション用状態（インスタンスごとに保持）
  let displayVideos = [];  // setVideos() で差し替えられる表示中の動画一覧
  let currentIndex = 0;
  const prevBtn   = IS_SHORTS ? document.getElementById('yt-modal-prev-' + SECTION_ID) : null;
  const nextBtn   = IS_SHORTS ? document.getElementById('yt-modal-next-' + SECTION_ID) : null;
  const counter   = IS_SHORTS ? document.getElementById('yt-modal-counter-' + SECTION_ID) : null;

  // ====== 商品ボトムシート データ層 ======
  const videoProductCache = {};
  let bsActiveProduct = null;
  let bsSelectedOptions = {};
  let bsSelectedQty = 1;

  function parseProductHandles(description) {
    if (!description) return [];
    const matches = description.match(/#([a-z0-9]+(?:-[a-z0-9]+)+)/g);
    if (!matches) return [];
    return [...new Set(matches.map(m => m.substring(1)))];
  }

  async function fetchProductsForVideo(video) {
    const vid = video.id;
    if (videoProductCache[vid]) return videoProductCache[vid];
    const handles = parseProductHandles(video.snippet.description);
    // 商品ページで、説明文から商品が見つからない場合は現在の商品をフォールバック
    if (handles.length === 0 && PRODUCT_HANDLE) {
      handles.push(PRODUCT_HANDLE);
    }
    if (handles.length === 0) { videoProductCache[vid] = []; return []; }
    const products = [];
    for (const handle of handles) {
      try {
        const res = await fetch(`/products/${handle}.js`);
        if (res.ok) products.push(await res.json());
      } catch (e) { /* ハンドル不正の場合スキップ */ }
    }
    // 商品ページで現在の商品が含まれていなければ追加
    if (PRODUCT_HANDLE && !products.find(p => p.handle === PRODUCT_HANDLE)) {
      try {
        const res = await fetch(`/products/${PRODUCT_HANDLE}.js`);
        if (res.ok) products.unshift(await res.json());
      } catch (e) { /* skip */ }
    }
    videoProductCache[vid] = products;
    return products;
  }

  function formatPrice(cents) {
    return '¥' + Math.floor(cents / 100).toLocaleString();
  }

  function findVariant(product, opts) {
    return product.variants.find(v =>
      product.options.every((o, i) => v['option' + (i + 1)] === opts[o.name])
    );
  }

  // カラーグループデータ（Liquidで事前に埋め込み済み）
  const colorGroupEl = document.getElementById('yt-color-group-' + SECTION_ID);
  const colorGroupProducts = colorGroupEl ? JSON.parse(colorGroupEl.textContent) : [];

  // 指定商品のカラーグループ内での兄弟商品を取得
  function findColorSiblings(product) {
    if (colorGroupProducts.length <= 1) return [];
    const found = colorGroupProducts.find(cp => cp.handle === product.handle);
    return found ? colorGroupProducts : [];
  }

  async function addToCartAjax(variantId, quantity) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity }] })
    });
    if (!res.ok) return false;
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    // テーマのカートキャッシュを更新
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'variant:add', cart }
    }));
    document.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'variant:add', cart }
    }));
    // カートドロワー/ページの再取得を強制
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    return true;
  }

  // ====== 商品ボトムシート 描画 ======
  function renderProductList(container, products, heading) {
    // 引数なしの場合、前回セット済みの見出しを再利用（詳細→戻る遷移時）
    if (heading) container.dataset.heading = heading;
    const headingText = container.dataset.heading || 'この動画の商品';
    container.innerHTML = `
      <div class="yt-bottomsheet__pill"></div>
      <div class="yt-bottomsheet__heading">${headingText}</div>
      <div class="yt-bottomsheet__scroll">
        ${products.map((p, i) => `
          <div class="yt-product-row" data-product-index="${i}">
            <img class="yt-product-row__thumb" src="${p.images[0] ? p.images[0].replace(/\.([^.]+)$/, '_160x160.$1') : ''}" alt="${p.title}" loading="lazy">
            <div class="yt-product-row__info">
              <div class="yt-product-row__vendor">${p.vendor || ''}</div>
              <div class="yt-product-row__title">${p.title}</div>
              <div class="yt-product-row__price">${formatPrice(p.price)}</div>
            </div>
            <button class="yt-product-row__add-btn" aria-label="${p.title}をカートに追加">
              <svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            </button>
          </div>
        `).join('')}
      </div>
      <div class="yt-cart-toast">
        <span>カートに追加されました</span>
        <a href="/cart" class="yt-cart-toast__link">カートに行く</a>
      </div>
    `;

    container.querySelectorAll('.yt-product-row__add-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const row = btn.closest('.yt-product-row');
        const idx = parseInt(row.dataset.productIndex);
        renderProductDetail(container, products[idx], products);
      });
    });
  }

  function renderProductDetail(container, product, allProducts) {
    bsActiveProduct = product;
    bsSelectedQty = 1;
    bsSelectedOptions = {};
    // デフォルトで最初の利用可能なバリアントのオプションを選択
    const firstAvail = product.variants.find(v => v.available) || product.variants[0];
    if (firstAvail) {
      product.options.forEach((o, i) => {
        bsSelectedOptions[o.name] = firstAvail['option' + (i + 1)];
      });
    }

    // 特定のオプション値が在庫切れかどうかを判定
    function isOptionValueDisabled(optionName, value) {
      // 現在の選択状態をコピーし、対象オプションだけ差し替え
      const testOpts = { ...bsSelectedOptions, [optionName]: value };
      const variant = findVariant(product, testOpts);
      return variant ? !variant.available : true;
    }

    function render() {
      const variant = findVariant(product, bsSelectedOptions);
      const price = variant ? variant.price : product.price;
      const available = variant ? variant.available : false;
      const img = variant && variant.featured_image ? variant.featured_image.src : (product.images[0] || '');
      const thumbSrc = img ? img.replace(/\.([^.]+)$/, '_160x160.$1') : '';

      container.innerHTML = `
        <div class="yt-bottomsheet__pill"></div>
        <div class="yt-detail__header">
          <button class="yt-detail__back" aria-label="戻る">‹</button>
          <span class="yt-detail__header-title">この商品をカートに入れますか？</span>
        </div>
        <div class="yt-bottomsheet__scroll">
          <div class="yt-detail__product-info">
            <img src="${thumbSrc}" alt="${product.title}">
            <div class="yt-product-row__info">
              <div class="yt-product-row__vendor">${product.vendor || ''}</div>
              <div class="yt-product-row__title">${product.title}</div>
              <div class="yt-product-row__price">${formatPrice(price)}</div>
            </div>
          </div>
          <div class="yt-detail__separator"></div>
          <div class="yt-detail__options">
            ${(() => {
              const colorSiblings = findColorSiblings(product);
              if (colorSiblings.length > 0) {
                return `
                  <div class="yt-detail__option-label">カラー</div>
                  <div class="yt-detail__option-values">
                    ${colorSiblings.map(cp => {
                      const isActive = cp.handle === product.handle;
                      return `
                        <input class="sr-only" type="radio" name="bs-color" id="bs-color-${cp.handle}" value="${cp.handle}" ${isActive ? 'checked' : ''}>
                        <label class="block-swatch" for="bs-color-${cp.handle}" data-color-handle="${cp.handle}">${cp.color_label}</label>
                      `;
                    }).join('')}
                  </div>
                `;
              }
              return '';
            })()}
            ${product.options.map(o => `
              <div class="yt-detail__option-label">${o.name}</div>
              <div class="yt-detail__option-values">
                ${o.values.map(val => {
                  const isActive = bsSelectedOptions[o.name] === val;
                  const disabled = isOptionValueDisabled(o.name, val);
                  return `
                    <input class="sr-only" type="radio" name="bs-${o.name}" id="bs-opt-${o.name}-${val}" value="${val}" ${isActive ? 'checked' : ''} ${disabled ? 'disabled' : ''}>
                    <label class="block-swatch${disabled ? ' is-disabled' : ''}" for="bs-opt-${o.name}-${val}" data-option-name="${o.name}" data-option-value="${val}">${val}</label>
                  `;
                }).join('')}
              </div>
            `).join('')}
            <div class="yt-detail__option-label">数量</div>
            <div class="quantity-selector" style="border-radius: var(--input-border-radius);">
              <button class="quantity-selector__button yt-qty-dec" ${bsSelectedQty <= 1 ? 'disabled' : ''} aria-label="数量を減らす">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="2" viewBox="0 0 10 2"><path d="M1 1h8" fill="none" stroke="currentColor" stroke-linecap="round"/></svg>
              </button>
              <input class="quantity-selector__input" type="text" value="${bsSelectedQty}" readonly>
              <button class="quantity-selector__button yt-qty-inc" aria-label="数量を増やす">
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"><path d="M1 5h8M5 1v8" fill="none" stroke="currentColor" stroke-linecap="round"/></svg>
              </button>
            </div>
          </div>
        </div>
        <div class="yt-detail__footer">
          <div class="yt-detail__subtotal">
            <span class="yt-detail__subtotal-label">小計</span>
            <span class="yt-detail__subtotal-price">${formatPrice(price * bsSelectedQty)}</span>
          </div>
          <button class="yt-cart-btn"${!available ? ' disabled' : ''}>${available ? 'カートに追加' : '売り切れ'}</button>
        </div>
      `;

      // カラー切り替え（別商品データを取得して遷移）
      container.querySelectorAll('[data-color-handle]').forEach(label => {
        label.addEventListener('click', async () => {
          const handle = label.dataset.colorHandle;
          if (handle === product.handle) return;
          // まず allProducts 内を検索、なければ fetch
          let newProduct = allProducts.find(p => p.handle === handle);
          if (!newProduct) {
            try {
              const res = await fetch(`/products/${handle}.js`);
              if (res.ok) {
                newProduct = await res.json();
                allProducts.push(newProduct);
              }
            } catch (e) { /* skip */ }
          }
          if (newProduct) renderProductDetail(container, newProduct, allProducts);
        });
      });

      // サイズ等のオプションボタン（block-swatch label）
      container.querySelectorAll('.block-swatch[data-option-name]').forEach(label => {
        label.addEventListener('click', (e) => {
          const input = document.getElementById(label.getAttribute('for'));
          if (input && input.disabled) { e.preventDefault(); return; }
          bsSelectedOptions[label.dataset.optionName] = label.dataset.optionValue;
          render();
        });
      });

      // 数量ボタン
      const decBtn = container.querySelector('.yt-qty-dec');
      const incBtn = container.querySelector('.yt-qty-inc');
      if (decBtn) decBtn.addEventListener('click', () => { if (bsSelectedQty > 1) { bsSelectedQty--; render(); } });
      if (incBtn) incBtn.addEventListener('click', () => { bsSelectedQty++; render(); });

      // 戻るボタン
      container.querySelector('.yt-detail__back').addEventListener('click', () => {
        renderProductList(container, allProducts);
      });

      // カート追加ボタン
      const cartBtn = container.querySelector('.yt-cart-btn');
      if (cartBtn && available) {
        cartBtn.addEventListener('click', async () => {
          cartBtn.disabled = true;
          cartBtn.textContent = '追加中...';
          const ok = await addToCartAjax(variant.id, bsSelectedQty);
          if (ok) {
            renderProductList(container, allProducts);
            showCartToast(container);
          } else {
            cartBtn.textContent = 'エラーが発生しました';
            setTimeout(() => { cartBtn.textContent = 'カートに追加'; cartBtn.disabled = false; }, 2000);
          }
        });
      }
    }

    render();
  }

  function showCartToast(container) {
    const toast = container.querySelector('.yt-cart-toast');
    if (!toast) return;
    requestAnimationFrame(() => {
      toast.classList.add('is-visible');
      setTimeout(() => { toast.classList.remove('is-visible'); }, 3000);
    });
  }

  // ====== 商品FAB → ボトムシート連携 ======
  async function loadProductsForSlide(slideEl, video) {
    if (!IS_SHORTS) return;
    const sheet = slideEl.querySelector('.yt-bottomsheet');
    const fab = slideEl.querySelector('.yt-product-fab');
    if (!sheet || !fab) return;

    const products = await fetchProductsForVideo(video);
    if (products.length > 0) {
      // FABを表示（バッジに商品数を設定）
      fab.querySelector('.yt-product-fab__badge').textContent = products.length;
      fab.classList.add('is-visible');
      // ボトムシートの中身を準備しておく（非表示のまま）
      renderProductList(sheet, products);

      // ボトムシートを閉じてFABに戻す
      function closeBottomSheet() {
        slideEl.classList.remove('has-products');
        sheet.style.display = 'none';
      }

      // FABタップ → ボトムシートを開く
      fab.onclick = () => {
        slideEl.classList.add('has-products');
        sheet.style.display = '';
      };
      // ボトムシートのピルをタップ → 閉じる
      sheet.addEventListener('click', (e) => {
        if (e.target.closest('.yt-bottomsheet__pill')) closeBottomSheet();
      });
      // ボトムシートを下スワイプ → 閉じる
      let bsSwipeStartY = 0;
      sheet.addEventListener('touchstart', (e) => {
        bsSwipeStartY = e.touches[0].clientY;
      }, { passive: true });
      sheet.addEventListener('touchend', (e) => {
        const dy = e.changedTouches[0].clientY - bsSwipeStartY;
        if (dy > 60) closeBottomSheet();
      }, { passive: true });
    } else {
      fab.classList.remove('is-visible');
      slideEl.classList.remove('has-products');
      sheet.style.display = 'none';
    }
  }

  const modalInfo    = document.getElementById('yt-modal-info-' + SECTION_ID);
  const modalTitle   = document.getElementById('yt-modal-title-' + SECTION_ID);
  const modalMeta    = document.getElementById('yt-modal-meta-' + SECTION_ID);
  const modalDesc    = document.getElementById('yt-modal-desc-' + SECTION_ID);
  const modalToggle  = document.getElementById('yt-modal-desc-toggle-' + SECTION_ID);

  modalToggle.addEventListener('click', () => {
    const collapsed = modalDesc.classList.toggle('is-collapsed');
    modalToggle.textContent = collapsed ? 'もっと見る ▾' : '閉じる ▴';
  });

  const isMobile = () => window.innerWidth <= 640;
  const slider = IS_SHORTS ? document.getElementById('yt-modal-slider-' + SECTION_ID) : null;

  // PC用: 単一iframe表示
  function showVideo(index) {
    const video = displayVideos[index];
    if (!video) return;
    currentIndex = index;
    const muteParam = isMuted ? 1 : 0;
    iframe.src = `https://www.youtube.com/embed/${video.id}?autoplay=1&mute=${muteParam}&rel=0&playsinline=1&enablejsapi=1`;
    const s = video.snippet;
    const views = formatViews(video.statistics?.viewCount);
    const date = new Date(s.publishedAt).toLocaleDateString('ja-JP', { year: 'numeric', month: 'long', day: 'numeric' });
    modalTitle.textContent = s.title;
    modalMeta.innerHTML = `<span>${views}回視聴</span><span>${date}</span>`;
    modalDesc.textContent = s.description || '';
    modalDesc.classList.add('is-collapsed');
    modalToggle.textContent = 'もっと見る ▾';
    modalToggle.style.display = s.description && s.description.length > 100 ? 'block' : 'none';
    modalInfo.style.display = 'block';

    if (IS_SHORTS) {
      prevBtn.disabled = index === 0;
      nextBtn.disabled = index === displayVideos.length - 1;
      counter.textContent = `${index + 1} / ${displayVideos.length}`;
    }
  }

  // SP用: スライダーのスライドを構築
  function buildSlides() {
    if (!slider || !IS_SHORTS) return;
    slider.innerHTML = displayVideos.map((v, i) => {
      const s = v.snippet;
      const views = formatViews(v.statistics?.viewCount);
      const date = new Date(s.publishedAt).toLocaleDateString('ja-JP', { year: 'numeric', month: 'long', day: 'numeric' });
      return `
        <div class="yt-modal__slide" data-slide-index="${i}">
          <div class="yt-modal__video">
            <div class="yt-modal__touch-layer"></div>
            <button class="yt-modal__mute-btn yt-slide-mute-btn" aria-label="音声ON/OFF">
              <svg viewBox="0 0 24 24" class="yt-mute-icon-off"><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/></svg>
              <svg viewBox="0 0 24 24" class="yt-mute-icon-on" style="display:none"><path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/></svg>
            </button>
            <div class="yt-slide-loading">ショートを読み込み中</div>
            <iframe data-video-id="${v.id}" src="" allowfullscreen allow="autoplay; encrypted-media"></iframe>
          </div>
          <div class="yt-modal__info" style="display:block">
            <h3 class="yt-modal__title">${s.title}</h3>
            <div class="yt-modal__meta"><span>${views}回視聴</span><span>${date}</span></div>
          </div>
          <button class="yt-product-fab" aria-label="この動画の商品を見る">
            <span class="yt-product-fab__icon">${CART_ICON_SVG}</span>
            <span class="yt-product-fab__badge">0</span>
          </button>
          <div class="yt-bottomsheet" style="display:none"></div>
        </div>
      `;
    }).join('');
  }

  // SP: 指定indexのスライドへ移動
  function goToSlide(index, animate) {
    if (index < 0 || index >= displayVideos.length) return;

    const prevIndex = currentIndex;
    currentIndex = index;

    if (animate) {
      slider.style.transition = 'transform 0.35s cubic-bezier(0.25, 0.1, 0.25, 1)';
    } else {
      slider.style.transition = 'none';
    }
    slider.style.transform = `translateY(-${currentIndex * 100}%)`;

    counter.textContent = `${currentIndex + 1} / ${displayVideos.length}`;

    // 前のスライドのiframeをクリア + ローディング表示を復元
    if (prevIndex !== currentIndex) {
      const prevSlideEl = slider.querySelector(`[data-slide-index="${prevIndex}"]`);
      if (prevSlideEl) {
        const prevIframe = prevSlideEl.querySelector('iframe');
        if (prevIframe) prevIframe.src = '';
        const prevLoading = prevSlideEl.querySelector('.yt-slide-loading');
        if (prevLoading) prevLoading.classList.remove('is-hidden');
      }
    }

    // スライド移動時はミュート状態にリセット
    isMuted = true;
    if (slider) {
      slider.querySelectorAll('.yt-slide-mute-btn').forEach(b => updateMuteIcon(b, true));
    }

    // 商品情報を先に取得 → FAB表示と動画再生を同時に開始
    const curSlide = slider.querySelector(`[data-slide-index="${currentIndex}"]`);
    const curIframe = slider.querySelector(`[data-slide-index="${currentIndex}"] iframe`);
    const curLoading = curSlide ? curSlide.querySelector('.yt-slide-loading') : null;
    const startPlayback = () => {
      if (curIframe) {
        curIframe.src = `https://www.youtube.com/embed/${displayVideos[currentIndex].id}?autoplay=1&mute=1&rel=0&playsinline=1&enablejsapi=1&controls=0`;
        // iframe読み込み完了でローディングを非表示
        curIframe.onload = () => {
          if (curLoading) curLoading.classList.add('is-hidden');
        };
      }
    };

    if (curSlide) {
      loadProductsForSlide(curSlide, displayVideos[currentIndex]).then(() => {
        startPlayback();
      });
    } else {
      startPlayback();
    }
  }

    function open(videoId) {
    currentIndex = displayVideos.findIndex(v => v.id === videoId);
    if (currentIndex < 0) currentIndex = 0;

    if (IS_SHORTS && isMobile()) {
      goToSlide(currentIndex, false);
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    } else if (!IS_SHORTS && isMobile()) {
      // SP通常動画: 先にレイアウト確定 → 商品取得 → 動画再生開始
      const currentVideo = displayVideos[currentIndex];
      const s = currentVideo.snippet;
      const views = formatViews(currentVideo.statistics?.viewCount);
      const date = new Date(s.publishedAt).toLocaleDateString('ja-JP', { year: 'numeric', month: 'long', day: 'numeric' });

      // レイアウトを先に確定（動画はまだ読み込まない）
      iframe.src = '';
      modal.classList.add('has-sp-products');
      modalTitle.textContent = s.title;
      modalMeta.innerHTML = `<span>${views}回視聴</span><span>${date}</span>`;
      modalInfo.style.display = 'block';
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      // ボトムシートにローディング表示
      const pcSheet = document.getElementById('yt-modal-bottomsheet-' + SECTION_ID);
      if (pcSheet) {
        pcSheet.style.display = '';
        pcSheet.innerHTML = '<div class="yt-bottomsheet__pill"></div><div style="text-align:center;padding:40px 0;color:#aaa;font-size:var(--text-base);">読み込み中...</div>';
      }

      // 商品取得 → 商品表示と動画再生を同時に開始（商品の有無にかかわらずボトムシート維持）
      fetchProductsForVideo(currentVideo).then(products => {
        if (pcSheet) {
          if (products.length > 0) {
            renderProductList(pcSheet, products);
          } else {
            pcSheet.dataset.heading = 'この動画の商品';
            pcSheet.innerHTML = `
              <div class="yt-bottomsheet__pill"></div>
              <div class="yt-bottomsheet__heading">この動画の商品</div>
              <div class="yt-bottomsheet__empty">紐づいている商品がありません。</div>
            `;
          }
        }
        // 商品準備完了後に動画再生開始
        const muteParam = isMuted ? 1 : 0;
        iframe.src = `https://www.youtube.com/embed/${currentVideo.id}?autoplay=1&mute=${muteParam}&rel=0&playsinline=1&enablejsapi=1`;
      });
    } else {
      // PC: サイドパネル型レイアウト（商品の有無にかかわらず常時表示）
      const currentVideo = displayVideos[currentIndex];
      const pcSheet = document.getElementById('yt-modal-bottomsheet-' + SECTION_ID);
      const cached = videoProductCache[currentVideo.id];

      modal.classList.add('has-pc-products');
      if (pcSheet) {
        pcSheet.style.display = '';
        if (cached) {
          renderPcSidePanel(pcSheet, cached);
        } else {
          pcSheet.innerHTML = '<div class="yt-bottomsheet__heading">現在販売中の商品</div><div class="yt-bottomsheet__empty">読み込み中...</div>';
        }
      }

      showVideo(currentIndex);
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';

      if (!cached) {
        fetchProductsForVideo(currentVideo).then(products => {
          if (pcSheet) renderPcSidePanel(pcSheet, products);
        });
      }
    }
  }

  // PCサイドパネル: 商品があれば一覧、なければ空状態を表示
  function renderPcSidePanel(container, products) {
    if (products && products.length > 0) {
      renderProductList(container, products, '現在販売中の商品');
    } else {
      container.dataset.heading = '現在販売中の商品';
      container.innerHTML = `
        <div class="yt-bottomsheet__heading">現在販売中の商品</div>
        <div class="yt-bottomsheet__empty">紐づいている商品がありません。</div>
      `;
    }
  }

    function close() {
    // PC用iframe停止
    iframe.src = '';
    // SP用: 全スライドのiframeを停止＋srcクリア（次回開く時に再読み込み）
    if (slider) {
      slider.querySelectorAll('iframe').forEach(f => {
        sendPlayerCommand(f, 'pauseVideo');
        f.src = '';
      });
    }
    modal.classList.remove('is-open');
    modal.classList.remove('has-sp-products');
    modal.classList.remove('has-pc-products');
    document.body.style.overflow = '';
    // ミュート状態をリセット
    isMuted = true;
    if (pcMuteBtn) updateMuteIcon(pcMuteBtn, true);
    if (slider) {
      slider.querySelectorAll('.yt-slide-mute-btn').forEach(b => updateMuteIcon(b, true));
    }
  }

  // PCショート: 動画切替時にサイドパネルの商品も更新
  function showVideoAndRefreshProducts(idx) {
    showVideo(idx);
    const pcSheet = document.getElementById('yt-modal-bottomsheet-' + SECTION_ID);
    if (!pcSheet) return;
    modal.classList.add('has-pc-products');
    pcSheet.style.display = '';
    const cached = videoProductCache[displayVideos[idx].id];
    if (cached) {
      renderPcSidePanel(pcSheet, cached);
    } else {
      pcSheet.innerHTML = '<div class="yt-bottomsheet__heading">現在販売中の商品</div><div class="yt-bottomsheet__empty">読み込み中...</div>';
      fetchProductsForVideo(displayVideos[idx]).then(products => {
        renderPcSidePanel(pcSheet, products);
      });
    }
  }

  // PC: 矢印ボタン
  if (IS_SHORTS) {
    prevBtn.addEventListener('click', () => { if (currentIndex > 0) showVideoAndRefreshProducts(currentIndex - 1); });
    nextBtn.addEventListener('click', () => { if (currentIndex < displayVideos.length - 1) showVideoAndRefreshProducts(currentIndex + 1); });

    // SP: 上下スワイプ → スライダーをスライド移動
    let touchStartY = 0;
    let touchStartX = 0;
    let touchStartTime = 0;
    let isDragging = false;
    let isBottomSheetTouch = false;

    function handleTouchStart(e) {
      if (!isMobile()) return;
      // ボトムシート内のタッチはスライド切替から除外
      if (e.target.closest('.yt-bottomsheet')) {
        isBottomSheetTouch = true;
        return;
      }
      isBottomSheetTouch = false;
      touchStartY = e.touches[0].clientY;
      touchStartX = e.touches[0].clientX;
      touchStartTime = Date.now();
      isDragging = true;
      slider.style.transition = 'none';
    }

    function handleTouchMove(e) {
      if (!isMobile() || !isDragging || isBottomSheetTouch) return;
      const dy = e.touches[0].clientY - touchStartY;
      const dx = e.touches[0].clientX - touchStartX;
      if (Math.abs(dy) > Math.abs(dx)) {
        const baseOffset = currentIndex * 100;
        const dragPercent = (dy / window.innerHeight) * 100;
        slider.style.transform = `translateY(-${baseOffset - dragPercent}%)`;
      }
    }

    function handleTouchEnd(e) {
      if (isBottomSheetTouch) { isBottomSheetTouch = false; return; }
      if (!isMobile() || !isDragging) return;
      isDragging = false;
      const dy = e.changedTouches[0].clientY - touchStartY;
      const dx = e.changedTouches[0].clientX - touchStartX;
      const elapsed = Date.now() - touchStartTime;
      const velocity = Math.abs(dy) / elapsed;
      const isTap = Math.abs(dy) < 10 && Math.abs(dx) < 10 && elapsed < 300;

      if (isTap) {
        // タップ → タッチ層を一時的に非表示にして動画操作を許可
        const layer = e.target.closest('.yt-modal__touch-layer');
        if (layer) {
          layer.style.pointerEvents = 'none';
          setTimeout(() => { layer.style.pointerEvents = ''; }, 3000);
        }
        return;
      }

      if (Math.abs(dy) > Math.abs(dx) && (Math.abs(dy) > 60 || velocity > 0.3)) {
        if (dy < 0 && currentIndex < displayVideos.length - 1) {
          goToSlide(currentIndex + 1, true);
        } else if (dy > 0 && currentIndex > 0) {
          goToSlide(currentIndex - 1, true);
        } else {
          goToSlide(currentIndex, true);
        }
      } else {
        goToSlide(currentIndex, true);
      }
    }

    modal.addEventListener('touchstart', handleTouchStart, { passive: true });
    modal.addEventListener('touchmove', handleTouchMove, { passive: true });
    modal.addEventListener('touchend', handleTouchEnd, { passive: true });
  }

  // ミュート制御
  let isMuted = true;
  const pcMuteBtn = document.getElementById('yt-modal-mute-' + SECTION_ID);

  function sendPlayerCommand(targetIframe, cmd) {
    if (targetIframe && targetIframe.contentWindow) {
      targetIframe.contentWindow.postMessage(JSON.stringify({
        event: 'command', func: cmd, args: []
      }), '*');
    }
  }

  function updateMuteIcon(btn, muted) {
    if (!btn) return;
    btn.querySelector('.yt-mute-icon-off').style.display = muted ? '' : 'none';
    btn.querySelector('.yt-mute-icon-on').style.display = muted ? 'none' : '';
  }

  function toggleMute(targetIframe, btn) {
    isMuted = !isMuted;
    sendPlayerCommand(targetIframe, isMuted ? 'mute' : 'unMute');
    // 全ミュートボタンのアイコンを同期
    if (pcMuteBtn) updateMuteIcon(pcMuteBtn, isMuted);
    if (slider) {
      slider.querySelectorAll('.yt-slide-mute-btn').forEach(b => updateMuteIcon(b, isMuted));
    }
  }

  // PC: ミュートボタン
  if (pcMuteBtn) {
    pcMuteBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      toggleMute(iframe, pcMuteBtn);
    });
  }

  // SP: スライドのミュートボタン（タッチ層の上に配置）
  if (slider) {
    slider.addEventListener('click', (e) => {
      const muteBtn = e.target.closest('.yt-slide-mute-btn');
      if (muteBtn) {
        e.stopPropagation();
        const slide = muteBtn.closest('.yt-modal__slide');
        const slideIframe = slide.querySelector('iframe');
        toggleMute(slideIframe, muteBtn);
      }
    });
  }

  closeBtn.addEventListener('click', close);
  modal.addEventListener('click', e => { if (e.target === modal) close(); });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    if (IS_SHORTS && modal.classList.contains('is-open')) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        if (isMobile()) { if (currentIndex > 0) goToSlide(currentIndex - 1, true); }
        else { if (currentIndex > 0) showVideoAndRefreshProducts(currentIndex - 1); }
      }
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        if (isMobile()) { if (currentIndex < displayVideos.length - 1) goToSlide(currentIndex + 1, true); }
        else { if (currentIndex < displayVideos.length - 1) showVideoAndRefreshProducts(currentIndex + 1); }
      }
    }
  });

  // ====== 公開API ======
  async function setVideos(videos, options) {
    options = options || {};
    displayVideos = videos || [];
    if (IS_SHORTS) {
      if (options.prefetchProducts) {
        // 表示分の商品情報を先読み（旧 sortAndRender と同じタイミング）
        await Promise.all(displayVideos.map(v => fetchProductsForVideo(v)));
      }
      buildSlides();
    }
  }

  return { setVideos, open, close, helpers: { formatViews, timeAgo, parseDuration } };
}

  return { create: create };
})();
})();
